// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1___57084536ae095d8e1a5","cls2":"AccountMenu-cls2___15d512251ac8307ace3 AccountMenu-cls1___57084536ae095d8e1a5"};